import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './TrainerInformationComponent.module.scss';
import metadata from './TrainerInformationComponent.metadata.json5';

function TrainerInformationComponent(props) {

    const {
        data: TrainerInformationVM,
        updateWizardData,
        submissionVM,
        TrainerInformationPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addTrainerInformation = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            TrainerInformationVM.value = TrainerInformationVM.value || []

            const { _xCenter, _dtoName } = TrainerInformationVM;

            const TrainerInformationObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            TrainerInformationObjVM.isValidationReq.value = true;

            TrainerInformationVM.pushElement(
                TrainerInformationObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, TrainerInformationVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            TrainerInformationVM.value.splice(index, 1);
            _.set(submissionVM.value, TrainerInformationPath, TrainerInformationVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, TrainerInformationPath, TrainerInformationVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'namFie') {
                const value = item.namFie ? item.namFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.namFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'cerFie') {
                const value = item.cerFie ? item.cerFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.cerFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'yeaofexpFie') {
                const value = item.yeaofexpFie ? item.yeaofexpFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.yeaofexpFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'avehouworperweeFie') {
                const value = item.avehouworperweeFie ? item.avehouworperweeFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.avehouworperweeFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

        }, [handleValueChange, translator, TrainerInformationVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`TrainerInformationTable`]: {
            data: TrainerInformationVM.value,
        }

    }), [TrainerInformationVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addTrainerInformation,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            TrainerInformationVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [TrainerInformationVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={TrainerInformationVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TrainerInformationComponent.propTypes = wizardProps;
export default withRouter(TrainerInformationComponent);
